import React, { useState, useEffect } from "react";
import {  Col,  Form,  Input,  Modal,  message,  Row,  Select,  Radio,  Card,  Divider,  Alert, theme, Spin,} from "antd";
import { POST } from "../../frameworks/HttpClient";
import { URL_TANK, URL_PRODUCT, URL_SALE } from "../../constants/urls";
import useDropdownItem from "../../common/useDropdownItem";
import ErrorMessages from "../../common/ErrorMessages";
import { PRODUCT_TYPE } from "../../constants/string"
import _ from 'lodash';

export default function StorageTankTransferTransactionModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, onUpdate } = props;
  const [selectedType, setSelectedType] = useState("weight_only");
  const [originValue, setOriginValue] = useState(null);
  const [destinationValue, setDestinationValue] = useState(null);
  const [warningMessage, setWarningMessage] = useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [debouncedOrderRef, setDebouncedOrderRef] = React.useState('');
  const debounceOrderRef = React.useCallback(_.debounce((_searchVal) => { setDebouncedOrderRef(_searchVal) }, 800), []);
  const type = Form.useWatch("type", form);

  const handleTypeChange = (e) => {
    setSelectedType(e.target.value);
    if (e.target.value === "weight_only") {
      form.resetFields(["lot_no", "product", "order_ref"]);
    }
  };

  const {
    token: { colorPrimary },
  } = theme.useToken();

  const lotTankOptions = useDropdownItem({
    manual: true,
    url: URL_TANK.TANK_TRANSACTION,
    pagination: true,
    params: { page_size: 999, is_empty: false },
    label_renderer:  (option) => `${option.lot_no || "ล็อตว่าง"} [${ option.name || option.tank_name }] - ${option.current_weight}`,
  });

  const tankOptions = useDropdownItem({
    manual: true,
    url: URL_TANK.TANK,
    pagination: true,
    params: { page_size: 999 },
    label_renderer:  (option) => `${option.lot_no || "ล็อตว่าง"} [${ option.name || option.tank_name }] - ${option.current_weight}`,
  });

  const productOptions = useDropdownItem({
    manual: true,
    url: URL_PRODUCT.PRODUCT,
    label_renderer : (e) => e.short_name ? `${e.name} - ${e.short_name}` : `${e.name}`, 
    pagination: true,
    params: { page_size: 999, type: PRODUCT_TYPE.CONCENTRATE_LATEX },
  });

  const produceOrderOptions = useDropdownItem({
    manual: true,
    url: URL_SALE.PRODUCE_ORDER,
    pagination: true,
    params: { page_size: 999, lot_no : debouncedOrderRef , is_produced : false, type: PRODUCT_TYPE.CONCENTRATE_LATEX},
    value: 'id',
    label_renderer:  (option) =>`${option.lot_no || "ล็อตว่าง"} [${ option.buyer_name || "ไม่ทราบผู้ขาย" }] - ${option.require_weight}`
  });


  useEffect(() => {
    if (originValue && destinationValue) {
      const isSameTank = originValue.id === destinationValue.current_transaction;
      const isEmptyDestination = destinationValue.current_transaction === null
      if (isSameTank) {
        setSelectedType("new_lot");
        form.setFieldValue('type', "new_lot")
        setWarningMessage("แทงก์ที่ต้องการโอนย้าย เป็นแทงก์เดียวกัน")
      } else if (isEmptyDestination) {
        setSelectedType("new_lot");
        form.setFieldValue('type', "new_lot")
        setWarningMessage("แทงก์ที่ต้องการโอนย้าย เป็นแทงก์เปล่า")
      } else {
        setSelectedType("weight_only");
        form.setFieldValue('type', "weight_only")
        setWarningMessage(null)
      }
    } else {
      setSelectedType("weight_only");
      setWarningMessage(null)
    }
  }, [originValue, destinationValue]);

  useEffect(() => {
    if (open) {
      form.resetFields();
      lotTankOptions.fetchOptions();
      tankOptions.fetchOptions();
      produceOrderOptions.fetchOptions();
      productOptions.fetchOptions();
      setOriginValue(null);
      setDestinationValue(null);
    }
  }, [open]);


  useEffect(() => {
    form.resetFields(["lot_no", "product", "order_ref"]);
  },[type]);

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if (originValue?.current_weight < originValue?.current_weight) {
        setErrorMessages("น้ำหนักที่โอนเกินกว่าที่มีในแทงก์ต้นทาง");
        return;
      }
      await POST(URL_TANK.TANK_TRANSFER_TRANSACTION, data);
      onUpdate();
      onClose();
      setSelectedType("weight_only");
      setOriginValue(null);
      setDestinationValue(null);
      form.resetFields();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if(open)
      produceOrderOptions.fetchOptions();
  },[debouncedOrderRef])

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])


  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={"โอนย้าย"}
      cancelText="ยกเลิก"
      title={"โอนย้ายแทงก์"}
      width={600}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: colorPrimary },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages} />
      <Form form={form} layout="vertical">
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              label="ล็อตน้ำยางข้น (ต้นทาง)"
              name="origin"
              rules={[{ required: true, message: "กรุณาระบุต้นทาง" }]}
            >
              <Select
                showSearch
                placeholder="กรุณาระบุต้นทาง"
                options={lotTankOptions.options.filter((e) => e.state !== "end")}
                onSelect={(_, option) => {
                  setOriginValue(option);
                  lotTankOptions.fetchOptions();
                  form.setFieldValue('weight', option.current_weight)
                }}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="ล็อตน้ำยางข้น (ปลายทาง)"
              name="destination_tank"
              rules={[{ required: true, message: "กรุณาระบุปลายทาง" }]}
            >
              <Select
                showSearch
                placeholder="กรุณาระบุปลายทาง"
                options={tankOptions.options}
                onSelect={(value, option) => {
                  setDestinationValue(option);
                  tankOptions.fetchOptions();
                }}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          {warningMessage && (
            <Col span={24}>
              <Alert
                message={
                  warningMessage
                }
                type="warning"
                showIcon
                closable
              />
            </Col>
          )}
        </Row>

        <Card>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name="type"
                rules={[{ required: true, message: "กรุณาระบุประเภทการโอน" }]}
              >
                <Radio.Group
                  value={selectedType}
                  onChange={handleTypeChange}
                  style={{ width: "100%" }}
                >
                  <Radio
                    value="weight_only"
                    style={{ width: "100%" }}
                    disabled={ originValue && destinationValue && (!destinationValue.current_transaction || originValue.id === destinationValue.current_transaction) }
                  >
                    โอนย้ายเฉพาะน้ำหนัก
                  </Radio>
                  <Divider>หรือ</Divider>
                  <Radio value="new_lot" style={{ width: "100%" }}>
                    สร้าง Lot No.ใหม่
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label="หมายเลขล็อต"
                name="lot_no"
                rules={
                  selectedType === "new_lot"
                    ? [{ required: true, message: "กรุณาระบุหมายเลขล็อต" }]
                    : []
                }
              >
                <Input
                  autoComplete="off"
                  placeholder="หมายเลขล็อต"
                  disabled={selectedType === "weight_only"}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="เกรด (ชนิดสินค้า)"
                name="product"
                rules={
                  selectedType === "new_lot"
                    ? [{ required: true, message: "กรุณาระบุชนิดสินค้า" }]
                    : []
                }
              >
                <Select
                  showSearch
                  placeholder="กรุณาระบุชนิดสินค้า"
                  options={productOptions.options}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  style={{ width: "100%" }}
                  disabled={selectedType === "weight_only"}
                />
              </Form.Item>
            </Col>
            <Col span={24}> 
            <Form.Item
              label="ใบแจ้งผลิต"
              name="order_ref"
            > 
              <Select 
                initialvalues={"-"}
                autoComplete="off" 
                placeholder="ใบแจ้งผลิต"
                showSearch
                filterOption={false}
                notFoundContent={produceOrderOptions.loading ? <Spin size="small" /> : "-"}
                onSearch={debounceOrderRef}
                options={produceOrderOptions.options}
                allowClear={"-"}
                onClear={() => {form.resetFields(["lot_no", "product"])}}
                onSelect={(value, option) => {
                  form.setFieldValue("lot_no", option.lot_no)
                  form.setFieldValue("product", option.product)
                }}
                disabled={selectedType === "weight_only"}
              />
            </Form.Item>
            </Col>
          </Row>
        </Card>

        <Row gutter={12}>
          <Col span={24}>
            <Form.Item
              label="ปริมาณโอน (Kg)"
              name="weight"
              rules={[
                {
                  required: true,
                  message: "กรุณาระบุน้ำหนัก",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="น้ำหนักที่โอน"
                disabled={originValue && destinationValue && originValue.id === destinationValue.current_transaction }
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={12}>
          <Col span={24}>
            <Form.Item
              label="หมายเหตุ"
              name="note"
              rules={[{ required: false }]}
            >
              <Input placeholder="หมายเหตุ" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}